import type { EmailFormSchema } from './schema';

export const emailsFromToUpdateConverter = (emails: EmailFormSchema[]) => {
  return emails.map((item) => ({ id: item.id, default: (item?.pivot?.default ?? 0) === 1 }));
};
